/**
 * 配列を列ベースで分割する
 * 各列に rowCount 個のアイテムが縦に並ぶ形で分割
 * 足りない列は先頭のアイテムから補充する
 */
export function splitIntoColumns<T>(items: T[], rowCount: number): T[][] {
  const safeRowCount = Math.max(rowCount, 1);
  const columnCount = Math.ceil(items.length / safeRowCount);
  const columns: T[][] = [];
  let fillIndex = 0;
  for (let col = 0; col < columnCount; col++) {
    const column: T[] = [];
    for (let row = 0; row < safeRowCount; row++) {
      const index = row * columnCount + col;
      if (index < items.length) {
        column.push(items[index]);
      } else {
        column.push(items[fillIndex % items.length]);
        fillIndex++;
      }
    }
    columns.push(column);
  }
  return columns;
}
